<template>
  <div class="admin-alarm">
    <div class="top-header">
      <div class="top-header-wrap">
        <img
          src="@/assets/images/common/bul_arr_left_gray.svg"
          class="back-button"
          @click="$router.push({name: 'Dashboard'})"
        />
        알림센터
      </div>
    </div>
    <div class="alarm-wrap">
      <ul class="alarm-button">
        <li @click="alaramType = 'all'" :class="{active: alaramType === 'all'}">
          전체 알림
        </li>
        <li
          @click="alaramType = 'noCheck'"
          :class="{active: alaramType === 'noCheck'}"
        >
          미확인 알림
          <div v-if="noCheckAlarm.totalCount !== 0" class="count">
            {{ noCheckAlarm.totalCount }}
          </div>
        </li>
      </ul>
      <div class="alarm-section">
        <div v-if="alaramType === 'all'" class="title">
          최근 6개월 동안 받은 알림
        </div>
        <div
          v-if="alaramType === 'noCheck'"
          class="confirm-button"
          :class="{'confirm-button-disable': noCheckAlarm.totalCount === 0}"
          @click="noCheckAlarm.totalCount !== 0 ? alarmCheckAllUpdate() : ''"
        >
          <img
            v-if="noCheckAlarm.totalCount !== 0"
            src="@/assets/images/admin/icon_check_alarm.svg"
          />
          <img v-else src="@/assets/images/admin/icon_check_alarm_grey.svg" />
          모두 확인
        </div>
        <div class="line"></div>
        <ul class="alarm-list">
          <li
            v-for="(alarm, index) in alaramType === 'all'
              ? allAlarm.list
              : noCheckAlarm.list"
            :key="index"
          >
            <div class="date-wrap">
              <div class="date1">{{ alarm.NewSentAt.slice(2, 7) }}</div>
              <div class="date2">{{ alarm.NewSentAt.slice(8, 10) }}</div>
            </div>
            <ul class="content-list">
              <li
                v-for="(list, i) in alarm.list"
                :key="i"
                :class="{nocheck: list.status === '미확인'}"
              >
                <div class="content-wrap">
                  <div class="dotted"></div>
                  <div class="text">{{ list.contents }}</div>
                  <div class="date">{{ list.sentAt | date }}</div>
                </div>
                <a
                  :href="list.code | notification_code"
                  target="_blank"
                  @click="
                    list.status === '미확인' ? alarmCheckUpdate(list.id) : ''
                  "
                >
                  <div class="detail-button">상세보기</div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <div
          class="more-button"
          v-if="
            (alaramType === 'all' && allAlarm.page !== allAlarm.totalPage) ||
            (alaramType === 'noCheck' &&
              noCheckAlarm.page !== noCheckAlarm.totalPage)
          "
          @click="alarmList(alaramType)"
        >
          더보기 +
        </div>
        <div
          v-if="
            (alaramType === 'all' && !allAlarm.list.length) ||
            (alaramType === 'noCheck' && !noCheckAlarm.list.length)
          "
          class="alarm-list-empty"
        >
          <img src="@/assets/images/admin/icon_empty_alarm.svg" />
          <p>
            {{
              alaramType === "all"
                ? "받은 알림이 없습니다."
                : "미확인 알림이 없습니다."
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="footer">ⓒ QPICK</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alaramType: "all",
      allAlarm: {
        list: [],
        page: 1,
        totalPage: 1
      },
      noCheckAlarm: {
        list: [],
        page: 1,
        totalPage: 1,
        totalCount: 0
      }
    };
  },
  mounted() {
    this.alarmList("all", 1);
    this.alarmList("noCheck", 1);
  },
  methods: {
    // 알림 목록
    alarmList(type, page) {
      const pages = page
        ? page
        : type === "all"
        ? this.allAlarm.page + 1
        : this.noCheckAlarm.page + 1;

      const params = {
        page: pages,
        perPage: 20,
        status: type === "all" ? ["미확인", "확인"] : ["미확인"],
        sortBy: "-sentAt"
      };
      this.$store
        .dispatch("ModuleAlarm/actAlarmList", params)
        .then(response => {
          const data = response.data;
          const newData =
            page === 1
              ? []
              : type === "all"
              ? this.allAlarm.list
              : this.noCheckAlarm.list;
          data.list.map(i => {
            const date = this.$options.filters.date(i.sentAt).slice(0, 10);
            const index = newData.findIndex(e => e.NewSentAt === date);
            if (index === -1) {
              newData.push({
                NewSentAt: date,
                list: [i]
              });
            } else {
              newData[index].list.push(i);
            }
          });
          if (type === "all") {
            this.allAlarm.list = newData;
            this.allAlarm.page = data.header.page;
            this.allAlarm.totalPage = data.header.totalPage;
          } else {
            this.noCheckAlarm.list = newData;
            this.noCheckAlarm.page = data.header.page;
            this.noCheckAlarm.totalPage = data.header.totalPage;
            this.noCheckAlarm.totalCount = data.header.totalCount;
          }
          console.log(this.allAlarm.list, this.noCheckAlarm.list);
        });
    },
    // 알림 확인
    alarmCheckUpdate(id) {
      const params = {
        id
      };
      this.$store
        .dispatch("ModuleAlarm/actAlarmCheckUpdate", params)
        .then(() => {
          this.alarmList("all", 1);
          this.alarmList("noCheck", 1);
        });
    },
    // 알림 전체 확인
    alarmCheckAllUpdate() {
      this.$store.dispatch("ModuleAlarm/actAlarmCheckAllUpdate").then(() => {
        this.alarmList("all", 1);
        this.alarmList("noCheck", 1);
      });
    }
  }
};
</script>

<style lang="scss">
.admin-alarm {
  .top-header {
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
    height: 56px;
    line-height: 56px;

    .top-header-wrap {
      max-width: 1248px;
      margin: 0 auto;
      padding: 0 16px;

      img {
        margin-right: 16px;
        cursor: pointer;
      }
    }
  }

  .alarm-wrap {
    max-width: 1248px;
    margin: 0 auto;
    padding: 0 16px;
    margin-top: 24px;

    @media screen and (max-width: 1023px) {
      padding: 0;
    }

    .alarm-button {
      display: flex;
      margin-left: 16px;

      li {
        color: #606060;
        cursor: pointer;
        display: flex;
        align-items: center;
        padding-bottom: 5px;
        border-bottom: solid 3px transparent;

        &:first-child {
          margin-right: 40px;
        }

        .count {
          width: 20px;
          height: 20px;
          line-height: 20px;
          background: #54c7a2;
          border-radius: 50%;
          margin-left: 6px;
          font-size: 12px;
          color: #fff;
          text-align: center;
        }
      }

      .active {
        color: #309574;
        border-bottom: solid 3px #309574;
      }
    }

    .alarm-section {
      background: #ffffff;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      padding: 24px 24px 16px 24px;
      box-sizing: border-box;
      min-height: 939px;

      @media screen and (max-width: 1023px) {
        padding: 24px 16px;
        box-shadow: none;
        border-radius: 0px;
      }

      .title {
        font-size: 18px;
        color: #484948;

        @media screen and (max-width: 1023px) {
          font-size: 14px;
        }
      }

      .confirm-button {
        border: 1px solid #309574;
        border-radius: 4px;
        width: 84px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        font-weight: 500;
        font-size: 12px;
        color: #309574;

        img {
          margin-right: 4px;
          vertical-align: -1px;
        }
      }

      .confirm-button-disable {
        border: 1px solid #dcdcdc;
        color: #dcdcdc;
        cursor: default;
      }

      .line {
        background: #b7b7b7;
        height: 1px;
        width: 100%;
        margin-top: 16px;
        margin-bottom: 16px;
      }

      .alarm-list {
        > li {
          margin-bottom: 16px;
          display: flex;

          @media screen and (max-width: 1023px) {
            margin-bottom: 8px;
          }

          &:last-child {
            margin-bottom: 0px;
          }

          .date-wrap {
            @media screen and (max-width: 1023px) {
              display: none;
            }

            .date1 {
              color: #484948;
            }

            .date2 {
              font-size: 32px;
              font-weight: 700;
              margin-top: -5px;
            }
          }

          .content-list {
            margin-left: 16px;
            width: calc(100% - 57px);

            @media screen and (max-width: 1023px) {
              margin-left: 0;
              width: 100%;
            }

            .nocheck {
              .dotted {
                display: block !important;
              }
            }

            > li {
              background: #ffffff;
              border: 1px solid #dadada;
              box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
              border-radius: 8px;
              margin-bottom: 8px;
              padding: 22px 16px;
              box-sizing: border-box;
              display: flex;
              align-items: flex-end;

              &:last-child {
                margin-bottom: 0px;
              }

              .content-wrap {
                width: calc(100% - 50px);

                .dotted {
                  display: none;
                  width: 6px;
                  height: 6px;
                  background: #54c7a2;
                  border-radius: 50%;
                  margin-top: -6px;
                  margin-bottom: 4px;
                }

                .date {
                  color: #8d8d8d;
                  margin-top: 6px;
                  font-size: 12px;
                }
              }

              .detail-button {
                margin-left: auto;
                color: #026444;
                text-decoration-line: underline;
                font-size: 12px;
                cursor: pointer;
                margin-bottom: 12px;

                @media screen and (max-width: 1023px) {
                  margin-bottom: 0;
                }
              }
            }
          }
        }
      }

      .more-button {
        height: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        border: 1px solid #dcdcdc;
        border-radius: 8px;
        width: calc(100% - 57px);
        margin-left: auto;
        margin-top: 16px;
        color: #b7b7b7;
        font-size: 14px;

        @media screen and (max-width: 1023px) {
          width: 100%;
        }
      }

      .alarm-list-empty {
        background: #f7f9fc;
        padding: 174px 0 442px;
        text-align: center;

        @media screen and (max-width: 1023px) {
          padding: 156px 0 309px;
        }

        p {
          font-weight: 500;
          font-size: 14px;
          color: #309574;
          margin-top: 30px;
        }
      }
    }
  }

  .footer {
    margin: 40px 0;
    color: #8d8d8d;
    font-weight: 500;
    font-size: 12px;
    text-align: center;
  }
}
</style>
